import './App.css';
import 'antd/dist/antd.css';
import Login from './Login';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import * as actions from './redux/actions/auth';
import Logout from './Logout';
import EmployeeList from './components/EmployeeList';
import ProductList from './components/ProductList';
import CreateForm from './components/CreateForm';
import Dashboard from './components/Dashboard';
import CreateProduct from './components/CreateProduct';
import AgentList from './components/AgentList';
import CreateAgent from './components/CreateAgent';
import AgentDetail from './components/AgentDetail';
import CreateTransaction from './components/CreateTransaction';
import Sms from './components/Sms';
import Statement from './components/Statement';
import ReportDetail from './components/ReportDetail';
import Transfer from './components/Transfer';
import CollectorHistory from './components/CollectorHistory';
import Correction from './components/Correction';

class App extends Component {
  componentDidMount() {
    this.props.onAppLoad();
  }
  render() {
    let authRedirect = null;
    let path = this.props.authRedirectPath;
    if (!this.props.isAuthenticated) {
      authRedirect = <Redirect to="/login" />;
    }
    if (path === "/" && this.props.isAuthenticated) {
      authRedirect = <Redirect to="/winlose" />;
    }
    return (
      <div className="container">
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/logout">
            <Logout />
          </Route>
          <Route exact path="/dashboard">
            <Dashboard>
              <EmployeeList />
            </Dashboard>
          </Route>
          <Route exact path="/createUser">
            <Dashboard>
              <CreateForm />
            </Dashboard>
          </Route>
          <Route exact path="/createProduct">
            <Dashboard>
              <CreateProduct />
            </Dashboard>
          </Route>
          <Route exact path="/products">
            <Dashboard>
              <ProductList />
            </Dashboard>
          </Route>
          <Route exact path="/agents">
            <Dashboard>
              <AgentList />
            </Dashboard>
          </Route>
          <Route exact path="/createAgent">
            <Dashboard>
              <CreateAgent />
            </Dashboard>
          </Route>
          <Route exact path="/agentDetail">
            <Dashboard>
              <AgentDetail />
            </Dashboard>
          </Route>
          <Route exact path="/winlose">
            <Dashboard>
              <CreateTransaction />
            </Dashboard>
          </Route>
          <Route exact path="/reportsms">
            <Dashboard>
              <Sms />
            </Dashboard>
          </Route>
          <Route exact path="/statement">
            <Dashboard>
              <Statement />
            </Dashboard>
          </Route>
          <Route exact path="/reportDetail">
            <Dashboard>
              <ReportDetail />
            </Dashboard>
          </Route>
          <Route exact path="/transfer-collector">
            <Dashboard>
              <Transfer />
            </Dashboard>
          </Route>
          <Route exact path="/collector-history">
            <Dashboard>
              <CollectorHistory />
            </Dashboard>
          </Route>
          <Route exact path="/correction">
            <Dashboard>
              <Correction />
            </Dashboard>
          </Route>
        </Switch>
        {authRedirect}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    currentUser: state.auth.currentUser,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAppLoad: () => dispatch(actions.authCheckState()),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
